<template>
  <div class="wt-failed-asset">
    <div class="wt-asset-container">
      <div class="-stage-area">
        <span class="failed-icon">
          <img src="/resources/img/sad-face-icon.svg" />
        </span>
        <div class="failed-message">Failed to Upload</div>
      </div>
      <div class="wt-asset-actions">
        <wt-button
          type="transparent"
          text="Contact Support"
          @click="contactSupport"
          class="-min-width-unset -custom -remove-hover-background"
        />
        <wt-button
          type="transparent"
          text="Remove"
          @click="$emit('remove-asset', asset)"
          class="-min-width-unset -custom -remove-hover-background"
        />
      </div>
    </div>
  </div>
</template>

<script>
import app from 'app';

export default {
  props: {
    asset: { type: Object, required: true },
    csmChatMessage: {
      type: String,
      default:
        'Hi, \n' +
        'Something went wrong during uploading. \n' +
        'can you please check? \n' +
        'Thanks',
    },
  },

  methods: {
    contactSupport() {
      app.intercomController.showNewMessage(this.csmChatMessage).catch(() => {
        // fallback - if there no intercom, go to website support
        app.openSupportTab();
      });
    },
  },
};
</script>
